import { createContext, useContext, useEffect, useRef, useState } from "react";
import { DEFAULT_LANG, LANGS, STORAGE_KEY, resolveSync, countryToLang } from "./detectLanguage";
import { copy } from "./copy";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [init] = useState(() => resolveSync());
  const [lang, setLangState] = useState(init.lang);
  const manualRef = useRef(false);

  useEffect(() => {
    if (!init.needsGeo) return;
    let cancelled = false;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/geo`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (cancelled || manualRef.current) return;
        setLangState(countryToLang(d && d.country));
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [init.needsGeo]);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => {
    if (!LANGS.includes(l)) return;
    manualRef.current = true;
    try {
      localStorage.setItem(STORAGE_KEY, l);
    } catch (e) {}
    setLangState(l);
  };

  const t = (key) =>
    (copy[lang] && copy[lang][key]) || copy[DEFAULT_LANG][key] || key;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
